module.exports = {
  realm: 'FB',
  market: 'fr-BE',
  domain: 'fr.weightwatchers.be',
  countryId: '9000',
  vsPath: 'be/fr',
  spiceLocale: 'fb',
  vsUrl: 'https://www{env}weightwatchers.com/be/fr',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/fb/messages/',
  cmxSiteUrl: 'https://cmx{env}fr.weightwatchers.be/',
  currency: '€',
  decimalSeparator: ',',
  thousandSeparator: '.',
  currencyFormat: '%number €',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}fr.weightwatchers.be/login-apis/',
  loginWebUrl: 'https://auth{env}fr.weightwatchers.be/v2/login/',
  countryCode: 'BE',
  commUlr: 'https://commerce{env}weightwatchers.com/be/fr/api/',
  timezone1: 'Europe/Brussels',
  timezone2: '+01:00',
};
